import { NgModule } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { RouterModule, Routes } from "@angular/router";
import { BranchContactComponent } from "./branch-contact/branch-contact.component";
import { BranchGstDetailsComponent } from "./branch-gst-details/branch-gst-details.component";
import { EntityBranchFormComponent } from "./entity-branch-form/entity-branch-form.component";
import { EntityBranchListComponent } from "./entity-branch-list/entity-branch-list.component";
import { EntityDisplayComponent } from "./entity-display/entity-display.component";
import { EntityFormComponent } from "./entity-form/entity-form.component";
import { EntityListComponent } from "./entity-list/entity-list.component";
import { ViewLinkedCompaniesComponent } from "./view-linked-companies/view-linked-companies.component";

const routes:Routes=[
    {  
        path:'',
        data:{
          title:'Entity',
        },
        component:EntityListComponent
     },
     {
        path:'',
        component:EntityDisplayComponent,
        children:[
           {
              path:'add',
              data:{
                 title:'New Entity'
              },
              component:EntityFormComponent
           },
           {
               path:'edit/:id',
               data:{
                  title:'Edit Entity'
               },
               component:EntityFormComponent
           },
           {
               path:'view/:id',
               data:{
                  title:'View Entity'
               },
               component:EntityFormComponent
           },
           {
               path:'edit/:id/addBranch',
               data:{
                  title:'Add Branch'
               },
               component:EntityBranchFormComponent
           },
           {
               path:'edit/:id/editBranch/:branchId',
               data:{
                  title:'Edit Branch'
               },
               component:EntityBranchFormComponent
           }
        ]
     },
   //   {
   //      path:'add',
   //      data:{
   //         title:'New Entity',
   //      },
   //      component:EntityFormComponent
   //   },
   //   {
   //      path:'edit/:id',
   //      data:{
   //         title:'Edit Entity'
   //      },
   //      component:EntityFormComponent,
      //   children:[
      //      {
      //          path:'addBranch',
      //          data:{
      //             title:'Add Branch'
      //          },
      //          pathMatch:'full',
      //          component:EntityBranchFormComponent
      //     },
      //   ]
   //   },
     {
         path:'branch/:id',
         data:{
            title:'Entity Branch'
         },
         component:EntityBranchListComponent
     }
   //   {
   //       path:'branchGST',
   //       data:{
   //          title:'Branch GST'
   //       },
   //       component:BranchGstDetailsComponent
   //   },
   //   {
   //       path:'branchContact',
   //       data:{
   //          title:'Branch Contact'
   //       },
   //       component:BranchContactComponent
   //   },
   //   {
   //       path:'addBranch',
   //       data:{
   //          title:'Add Branch'
   //       },
   
   //       component:EntityBranchFormComponent
   //    },
]

@NgModule({
    imports:[RouterModule.forChild(routes)],
    exports:[RouterModule],
    providers:[
      {
         provide: MatDialogRef,
         useValue: {}
      },
      { 
          provide: MAT_DIALOG_DATA, 
          useValue: {} 
      },
    ]
})
export class ExternalEntityRoutingModule
{

}